export default "__VITE_ASSET__DLUavuGc__"